// DS: i4.39
import React from 'react';
import IconWrap from '../../IconWrap';
const PremiumGallery = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 5H25.1429C26.1685 5 27 5.83147 27 6.85714V23H25.0262V7.78131C25.0262 7.37104 24.6937 7.03845 24.2834 7.03845H9V5ZM5 10.8571C5 9.83147 5.83147 9 6.85714 9H21.1429C22.1685 9 23 9.83147 23 10.8571V25.1429C23 26.1685 22.1685 27 21.1429 27H6.85714C5.83147 27 5 26.1685 5 25.1429V10.8571ZM16.0016 14.3783L17.7952 15.3579C17.984 15.461 18.1 15.6502 18.1 15.8547V18.3974C18.1 18.5617 18.025 18.7182 17.8938 18.8273L14.2081 21.8947C13.9754 22.0884 13.6246 22.0884 13.3919 21.8947L9.70618 18.8273C9.57503 18.7182 9.5 18.5617 9.5 18.3974V15.8547C9.5 15.6502 9.61605 15.461 9.80476 15.3579L11.5984 14.3783C11.8151 14.26 12.0869 14.2769 12.285 14.4212L13.8 15.5244L15.315 14.4212C15.5131 14.2769 15.7849 14.26 16.0016 14.3783Z",
        fill: "currentColor"
    })));
PremiumGallery.displayName = 'PremiumGallery';
export default PremiumGallery;
